(function(){
  var localeRoot = (window.theme && window.theme.localeRootUrl) || '';
  var cartMap = {};

  function fetchCartAndUpdate() {
    fetch(localeRoot + '/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartMap = {};
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            var pid = item.product_id;
            if (cartMap[pid]) {
              cartMap[pid] += item.quantity;
            } else {
              cartMap[pid] = item.quantity;
            }
          }
        }
        updateAllBadges();
      })
      .catch(function() {});
  }

  function updateAllBadges() {
    var badges = document.querySelectorAll('[data-cart-badge]');
    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      var pid = parseInt(badge.getAttribute('data-cart-badge'), 10);
      var qty = cartMap[pid] || 0;
      if (qty > 0) {
        badge.querySelector('.cart-badge__qty').textContent = qty;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    }
  }

  window.CartBadge = { refresh: fetchCartAndUpdate, update: updateAllBadges };

  fetchCartAndUpdate();

  document.addEventListener('product:added', function() {
    setTimeout(fetchCartAndUpdate, 600);
  });
  document.addEventListener('cart:refresh', function() {
    setTimeout(fetchCartAndUpdate, 600);
  });
  document.addEventListener('cart:rerendered', function() {
    setTimeout(fetchCartAndUpdate, 600);
  });

  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType === 1 && (node.querySelector('[data-cart-badge]') || node.hasAttribute && node.hasAttribute('data-cart-badge'))) {
            updateAllBadges();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
